module.exports = __webpack_public_path__ + "static/media/pptFileIcon.3831b6ee.svg";